import { useEffect, useState } from "react";
import { formatedDate, getNextDayFormatted } from "../../services/hooks/formatedDate";
import { getSubscriptData } from "../../services/callAPI/toSubscription";
import { ErrorOccurred } from "../../services/utils/ErrorOccurred";
import ValidToast from "../../components/toasts/ValidToast";
import UnvalidToast from "../../components/toasts/UnvalidToast";
import { SpinnerC } from "../../components/spinners/SpinnerC";
import { Browser } from '@capacitor/browser';

/* main component */
interface ISubscriptionPageProps {
  id: number;
  type: string;
  subs_start: string;
  subs_end: string;
  next_payment: string;
  isWantPremiumSubs: boolean
}

function MobileSubscriptionPage() {
  //states
  const [_paymentVisible, _setPaymentVisible] = useState(false);
  const [userSubscription, setUserSubscription] = useState<ISubscriptionPageProps>();
  const [error, setError] = useState<boolean>(false);
  const [triggerUseEffect, _setTriggerUseEffect] = useState<boolean>(false);
  const [alsoSwitchToBasic, setalsoSwitchToBasic] = useState<boolean>(false);
  const [switchToBasicSucess, setswitchToBasicSucess] = useState<boolean>(false);
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [successInteres, setSuccessInteres] = useState(false);

const handleRedirect = async () => {
  try {
    await Browser.open({ url: 'https://www.cemade.fr' });
  } catch (error) {
    console.error("Erreur lors de l'ouverture de l'URL : ", error);
  }
};

  //handleGetSubscriptData
  useEffect(() => {
    //enable loading
    setisLoading(true);

    const handleGetSubscriptData = async () => {
      try {
        const subscriptionData = await getSubscriptData();
        setUserSubscription(subscriptionData);
        setError(false);
      } catch (error) {
        setError(true);
      }
      finally {
        setisLoading(false);
      }
    }
    handleGetSubscriptData();
  }, [triggerUseEffect]);

  if (error) {
    return <ErrorOccurred />
  } else if (userSubscription) {
    return (
      <>
        {switchToBasicSucess && <ValidToast message="Demande prise en compte !" onClose={() => setswitchToBasicSucess(false)} />}
        {alsoSwitchToBasic && <UnvalidToast message="Demande déja prise en compte !" onClose={() => setalsoSwitchToBasic(false)} />}
        {successInteres && <ValidToast message="Merci. Votre ton intérêt est pris en compte!" onClose={() => setSuccessInteres(false)} />}

        <section id="manage-subscrip" className="flex flex-col items-center justify-center h-full">

          <div id="div-manage-subs" className="w-full sm:w-2/3 md:w-1/2 bg-gray-100 rounded-lg flex flex-col items-center py-6 px-4">

            <h2 className="font-bold text-lg lg:text-xl mb-3">Mon abonnement Cemade</h2>

            {/* subscription type */}
            <p>Tu bénéficies de l'offre <strong>{userSubscription.type}</strong> depuis le {userSubscription ? formatedDate(userSubscription?.subs_start) : undefined}.</p>

            <span className="border-t border-gray-300 block w-11/12 my-4" />

            {/* subscription renewval */}
            {
              userSubscription.type === "BASIC" ?
                (
                  <>
                    <h3 className="font-bold lg:text-lg">L'abonnement sera renouvelé le</h3>
                    <p>{getNextDayFormatted(userSubscription.subs_end)} gratuitement</p>
                    <span className="border-t border-gray-300 block w-11/12 my-4" />
                  </>
                ) :
                (
                  <>
                    <h3 className="font-bold lg:text-lg">Prochain prélévement</h3>
                    <p>le {userSubscription.next_payment ? getNextDayFormatted(userSubscription?.subs_end) : undefined} à 2.99 €.</p>
                    <span className="border-t border-gray-300 block w-11/12 my-4" />
                  </>
                )
            }

            {/* change subscription */}
            <h3 className="font-bold pb-2 lg:text-lg">Tu souhaites changer d'offre ?</h3>

            <p className="pb-2">Rendez-vous sur notre site web pour mettre à jour ton abonnement.</p>
            
            <button
              onClick={handleRedirect}
              className="bg-orangeCustom text-white px-4 py-2 rounded-lg"
            >
              Aller sur le site
            </button>

          </div>

        </section>
      </>
    )
  } else if (!isLoading) {
    return null;
  } else if (isLoading) {
    return (
      <>
        <SpinnerC></SpinnerC>
        <p>Chargement des données...</p>
      </>
    )
  } else {
    return (
      <>
        <p>Oups quelque chose s'est mal passé... </p>
      </>
    )
  }
}
export default MobileSubscriptionPage;